import { Icon, Shadow, Text, HStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

interface SectionLockedProps {
  title: string;
}

export const SectionLocked: React.FC<SectionLockedProps> = ({ title }) => {
  return (
    <Shadow level={2} borderRadius={BoxRadius.sm}>
      <HStack
        alignItems="center"
        justifyContent="space-between"
        p={Spacing['inline.xxs']}
        bg="white"
        borderRadius={BoxRadius.sm}>
        <Text variant="bold" fontSize={Typography['fontsize.lg']} color="neutral.lightest">
          {title}
        </Text>
        <Icon testID="icon-lock" name="Locked" size="xs" color={Color['neutral.lightest']} />
      </HStack>
    </Shadow>
  );
};
